{
  "platform": "Plattform",
  "partner": "Partner",
  "tenants": "Mandanten",
  "customers": "Kunden",
  "partners": "Partner",
  "enquiries": "Anfragen",
  "teamAccess": "Team und Zugriff",
  "tenant": "Mandant",
  "yourTenants": "Ihre Mandanten",
  "noTenantAssignments": "Noch keine Mandantenzuweisungen.",
  "noPartnerCustomersYet": "Dieser Partner hat noch keine Kunden.",
  "onboarding": "Onboarding",
  "overview": "Übersicht",
  "users": "Benutzer",
  "groups": "Gruppen",
  "designer": "Designer",
  "rules": "Regeln",
  "campaigns": "Kampagnen",
  "tester": "Tester"
}
